import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavItemType } from 'src/app/components/nav-items/models/nav-item-type.enum';
import { NavItemModel } from 'src/app/components/nav-items/models/nav-item.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  footerLinks: Array<NavItemModel> = [
    {
      name: 'footer.requestAdvice',
      type: NavItemType.Link,
      isExternalLink: true,
      navigateTo: 'https://www.assekuranz.ch/servicecenter/kontakt',
    },
    {
      name: 'footer.overviewInsurances',
      type: NavItemType.Link,
      navigateTo:
        'https://www.assekuranz.ch/versicherung/ueberblick-versicherungen',
      isExternalLink: true,
    },
    {
      name: 'footer.reportDamage',
      type: NavItemType.Link,
      navigateTo: 'pages/claim',
    },
    {
      name: 'footer.calculatePremium',
      type: NavItemType.Link,
      navigateTo: 'pages/calculator',
    },
    {
      name: 'footer.changeAddress',
      type: NavItemType.Link,
      navigateTo: 'auth/request-address-change',
    },
    {
      name: 'footer.downloads',
      type: NavItemType.Link,
      isExternalLink: true,
      navigateTo: 'https://www.assekuranz.ch/servicecenter/downloads-und-links',
    },
    {
      name: 'footer.customerFeedback',
      type: NavItemType.Link,
      isExternalLink: true,
      navigateTo: 'https://www.assekuranz.ch/servicecenter/kontakt',
    },
  ];

  contactItems: Array<NavItemModel> = [
    {
      name: 'footer.address',
      type: NavItemType.Text,
    },
    {
      name: 'footer.postalCode',
      type: NavItemType.Text,
    },
    {
      name: 'footer.email',
      type: NavItemType.Email,
      navigateTo: 'info@assekuranz.ch',
    },
    {
      name: 'footer.googleMaps',
      type: NavItemType.Link,
      isExternalLink: true,
      navigateTo:
        'https://www.google.ch/maps/place/Assekuranz+AR/@47.3847121,9.2774266,18z/data=!3m1!4b1!4m6!3m5!1s0x479adf39e3c2d4f5:0x384867ee36f8ae0b!8m2!3d47.3847121!4d9.2774266!16s%2Fg%2F11smfl0l3g?hl=de&entry=ttu&g_ep=EgoyMDI1MDgxOS4wIKXMDSoASAFQAw%3D%3D',
    },
    {
      name: 'footer.contactPhone',
      type: NavItemType.Phone,
      navigateTo: '0713530053',
    },
  ];

  infoItems: Array<NavItemModel> = [
    {
      name: 'footer.openingHoursAm',
      type: NavItemType.Text,
    },
    {
      name: 'footer.openingHoursPm',
      type: NavItemType.Text,
    },
  ];

  show?: boolean;
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.showFooter();
    this.router.events.subscribe((val) => {
      this.showFooter();
    });
  }

  showFooter(): void {
    if (this.router.url.includes('home')) {
      this.show = true;
    } else {
      this.show = false;
    }
  }
}
